import React from 'react';
import { Feature } from 'core/enums/features';
import { BaseRoute } from 'core/models/base-routes';

export const HardwareRoutes: BaseRoute[] = [
  // FIXME: Commenting out due to field Tests
  // {
  //   path: '*',
  //   title: 'Hardware',
  //   name: 'product.hardware.tabs.allhardware',
  //   feature: Feature.Products,
  //   component: React.lazy(() => import('./tabs/all-hardware')),
  //   hideFromMainMenu: true,
  //   isActive: true,
  //   icon: 'icon-list',
  // },
  {
    path: '*',
    title: 'Devices',
    name: 'product.hardware.tabs.devices',
    feature: Feature.Products,
    component: React.lazy(() => import('./tabs/devices')),
    hideFromMainMenu: true,
    isActive: true,
    icon: 'icon-decoder',
  },
  {
    path: 'holiday',
    title: 'Holiday Home',
    name: 'product.hardware.tabs.holidayhome',
    feature: Feature.HolidayHome,
    component: React.lazy(() => import('./tabs/holiday-home')),
    hideFromMainMenu: true,
    icon: 'icon-Holiday_home',
  },
  {
    path: 'inactive',
    title: 'Inactive Devices',
    name: 'product.hardware.tabs.inactive',
    feature: Feature.Products,
    component: React.lazy(() => import('./tabs/inactive-hardware')),
    hideFromMainMenu: true,
    icon: 'icon-disconnect',
  },
  // NOTE: unlikely there will ever be internet devices here.
  // {
  //   path: 'internet',
  //   title: 'interent Devices',
  //   name: 'product.hardware.tabs.internet',
  //   feature: Feature.Products,
  //   component: React.lazy(() => import('./tabs/internet-devices')),
  //   hideFromMainMenu: true,
  //   icon: 'icon-disconnect',
  // },
];